import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=3c7c9bed&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=3c7c9bed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c9bed",
  null
  
)

export default component.exports